import React, { useState } from 'react';
import {
  StyledPara,
  StyledPanel,
  StyledCollapse,
  StyledContentWrapper,
  TableHeaderWrapper,
} from './styled';
import Tile from './Tile';

const ViewerMetadata = ({ viewerId, clientId }) => {
  const [label, setLabel] = useState('Show Client ID');
  const onPanelClick = (key) => {
    // When the panel is expanded, the length of key is 1, set to the active panel, else it's an empty object array
    setLabel(key.length ? 'Hide Client ID' : 'Show Client ID');
  };
  return (
    <StyledContentWrapper>
      <TableHeaderWrapper>Viewer Metadata</TableHeaderWrapper>
      <StyledCollapse bordered={false} onChange={onPanelClick}>
        <StyledPanel
          showArrow={false}
          header={<Tile name="Client ID" value={label} showDivider={false} />}
          key="1"
        >
          <StyledPara>{clientId}</StyledPara>
        </StyledPanel>
      </StyledCollapse>
      <Tile key={`${viewerId}`} name={'Viewer ID'} value={`${viewerId}`} />
    </StyledContentWrapper>
  );
};

export default ViewerMetadata;
